module.exports = __webpack_public_path__ + "e45ab30d4e5cfd10c806c05eb3ab5eb5.jpg";